import type { ResultComparison, WearingBoardItem } from '../../api/wearing-results';
import type { ChatAdminSummary } from '../../types/admin';

export function currentAdminProfileId(roster: readonly ChatAdminSummary[], userId: string | undefined): string | undefined {
  return roster.find((admin) => admin.user_id === userId)?.admin_id;
}

export function wearingResultUrl(patientId: string, cycleId: string, search: URLSearchParams): string {
  const target = new URLSearchParams(search);
  target.set('result_cycle', cycleId);
  return `/clients/${encodeURIComponent(patientId)}?${target.toString()}#result`;
}

export function filterWearingItems(items: readonly WearingBoardItem[], mineOnly: boolean, currentAdminId: string | undefined, selectedManagerIds: readonly string[], search: string): WearingBoardItem[] {
  return items.filter((item) => {
    const assignedManagers = item.manager_ids ?? (item.manager_id ? [item.manager_id] : []);
    if (mineOnly && (!currentAdminId || !assignedManagers.includes(currentAdminId))) return false;
    if (selectedManagerIds.length > 0 && !selectedManagerIds.some((managerId) => assignedManagers.includes(managerId))) return false;
    return !search || item.patient_name.toLocaleLowerCase().includes(search.toLocaleLowerCase());
  });
}

export function retakeChoices(result: ResultComparison): readonly string[] {
  return result.required_angles ?? result.paired_angles.filter((pair) => pair.after_url).map((pair) => pair.angle_type);
}
